import VueRouter, { Route, RouteConfig } from 'vue-router'

// ======= 基础功能，用户的主页等等
const OnlineMatchUserMineRoute = {
  path: '/online-matches/user/mine',
  name: 'online_matches_user_mine',
  meta: { title: '我的赛事' },
  component: () => import('../activity/onlineMatches/user/Mine.vue'),
}

const OnlineMatchUserMatchListRoute = {
  path: '/online-matches/user/match-list',
  name: 'online_matches_user_match_list',
  meta: { title: '赛事列表' },
  component: () => import('../activity/onlineMatches/user/MatchList.vue'),
}

const OnlineMatchUserAchievementRoute = {
  path: '/online-matches/user/achievement',
  name: 'online_matches_user_achievement',
  meta: { title: '赛事成就' },
  component: () => import('../activity/onlineMatches/user/Achievement.vue'),
}

const OnlineMatchUserScoreRankRoute = {
  path: '/online-matches/user/score-rank',
  name: 'online_matches_user_score_rank',
  meta: { title: '排行榜' },
  component: () => import('../activity/onlineMatches/user/ScoreRank.vue'),
}

export const guangdongLandingRoute: RouteConfig = {
  path: '/online-matches/guangdong/landing',
  component: () => import('../activity/onlineMatches/guangdong/Landing.vue'),
  children: [
    { path: '', redirect: 'main' },
    {
      path: 'detail',
      component: () => import('../activity/onlineMatches/guangdong/Introduce.vue'),
      meta: { title: '大赛介绍' },
    },
    {
      path: 'main',
      component: {
        render: (h: any) =>
          h('img', {
            style: { width: '100%' },
            attrs: {
              src:
                'https://cdn.tiantiantiaosheng.com/dataupload/tool/2021-07-12/99978d4c-eebd-4c38-9cf5-85cad0fc70d6/187b6a50-9a14-4c4d-8e43-593c26a544ca.png',
            },
          }),
      },
      meta: { title: '报名流程' },
    },
  ],
}

export const guangdongIndexRoute: RouteConfig = {
  path: '/online-matches/guangdong',
  component: () => import('../activity/onlineMatches/guangdong/Index.vue'),
  children: [
    { path: '', redirect: 'index' },
    {
      path: 'index',
      component: () => import('../activity/onlineMatches/guangdong/Introduce.vue'),
    },
    {
      path: 'trend',
      component: () => import('../activity/onlineMatches/guangdong/Trend.vue'),
    },
  ],
}

export const guangdongMainRoute: RouteConfig = {
  path: '/online-matches/guangdong/main',
  component: () => import('../activity/onlineMatches/guangdong/Main.vue'),
  meta: {
    title: '广东跳绳大赛',
  },
}

export const guangdongRankRoute: RouteConfig = {
  path: '/online-matches/guangdong/rank',
  name: 'online_matches_guangdong_rank',
  component: () => import('../activity/onlineMatches/guangdong/Rank.vue'),
  meta: {
    title: '广东跳绳大赛排名',
  },
}

export const guangdongHelpRoute: RouteConfig = {
  path: '/online-matches/guangdong/help',
  name: 'online_matches_guangdong_help',
  component: () => import('../activity/onlineMatches/guangdong/Help.vue'),
  meta: {
    title: '广东跳绳大赛介绍',
  },
}

export const guangdongCertRoute: RouteConfig = {
  path: '/online-matches/guangdong/cert',
  name: 'online_matches_guangdong_cert',
  component: () => import('../activity/onlineMatches/guangdong/Certificate.vue'),
  props: (route) => ({ ...route.query }),
  meta: {
    title: '大赛证书',
  },
}

export const ganzhouLandingRoute: RouteConfig = {
  path: '/online-matches-ganzhou-landing',
  name: 'online_matches_ganzhou_landing',
  component: () => import('../activity/onlineMatches/ganzhou/Landing.vue'),
  meta: {
    title: '建党100周年比赛报名',
  },
}

export const ganzhouRegistRoute: RouteConfig = {
  path: '/online-matches-ganzhou-regist',
  name: 'online_matches_ganzhou_regist',
  component: () => import('../activity/onlineMatches/ganzhou/Regist.vue'),
  meta: {
    title: '认证',
  },
}

export const ganzhouMainRoute: RouteConfig = {
  path: '/online-matches-ganzhou-main',
  name: 'online_matches_ganzhou_main',
  component: () => import('../activity/onlineMatches/ganzhou/Main.vue'),
  meta: {
    title: '建党100周年比赛',
  },
}

export const ganzhouBoardRoute: RouteConfig = {
  path: '/online-matches-ganzhou-board',
  name: 'online_matches_ganzhou_board',
  component: () => import('../activity/onlineMatches/ganzhou/Board.vue'),
  meta: {
    title: '跳绳大赛排行榜',
  },
}

export const xixiaIndexRoute: RouteConfig = {
  path: '/online-matches/xixia',
  name: 'online_matches_xixia',
  component: () => import('../activity/onlineMatches/xixia/Index.vue'),
  meta: {
    title: '西峡跳绳比赛',
  },
}

export const xixiaCertRoute: RouteConfig = {
  path: '/online-matches/xixia/cert',
  name: 'online_matches_xixia_cert',
  component: () => import('../activity/onlineMatches/xixia/Certificate.vue'),
  props: (route) => ({ ...route.query }),
  meta: {
    title: '大赛证书',
  },
}

export const xixiaRankRoute: RouteConfig = {
  path: '/online-matches/xixia/rank',
  name: 'online_matches_xixia_rank',
  component: () => import('../activity/onlineMatches/xixia/Rank.vue'),
  meta: {
    title: '西峡跳绳大赛排名',
  },
}

export const xixiaHelpRoute: RouteConfig = {
  path: '/online-matches/xixia/help',
  name: 'online_matches_xixia_help',
  component: () => import('../activity/onlineMatches/xixia/Help.vue'),
  meta: {
    title: '西峡跳绳大赛介绍',
  },
}

export const xixiaLandingRoute: RouteConfig = {
  path: '/online-matches/xixia/landing',
  name: 'online_matches_xixia_landing',
  component: () => import('../activity/onlineMatches/xixia/Landing.vue'),
  meta: {
    title: '西峡跳绳大赛',
  },
}

export const guangdongRulesRoute: RouteConfig = {
  path: '/online-matches/guangdong/rules',
  name: 'online_matches_guangdong_rules',
  component: () => import('../activity/onlineMatches/guangdong/Rules.vue'),
  meta: {
    title: '广东省大赛文件',
  },
}

export const guangdongVoteRoute: RouteConfig = {
  path: '/online-matches/guangdong/vote',
  name: 'online_matches_guangdong_vote',
  component: () => import('../activity/onlineMatches/guangdong/Vote.vue'),
  meta: {
    title: '广东城市跳绳大赛',
  },
}

export const guangdongVoteLandingRoute: RouteConfig = {
  path: '/online-matches/guangdong/vote-landing',
  name: 'online_matches_guangdong_vote_landing',
  component: () => import('../activity/onlineMatches/guangdong/VoteLanding.vue'),
  meta: {
    title: '广东省比赛专题',
  },
}

export const guangdongCityOpenRoute: RouteConfig = {
  path: '/online-matches/guangdong-city-open',
  name: 'online_matches_guangdong_city_open',
  component: () => import('../activity/onlineMatches/guangdongCityOpen/Index.vue'),
  meta: {
    title: '广东省比赛专题',
  },
}

export const guangdongCityOpenSignupRoute: RouteConfig = {
  path: '/online-matches/guangdong-city-open/signup',
  name: 'online_matches_guangdong_city_open_signup',
  component: () => import('../activity/onlineMatches/guangdongCityOpen/Signup.vue'),
  meta: {
    title: '广东省比赛专题',
  },
}

export const zhejiangRoutes = [
  {
    path: '/online-matches/zhejiang',
    name: 'online_matches_zhejiang',
    component: () => import('../activity/onlineMatches/zhejiang/Index.vue'),
    meta: {
      title: '浙江省跳绳比赛',
    },
  },
  {
    path: '/online-matches/zhejiang/rank',
    name: 'online_matches_zhejiang_rank',
    component: () => import('../activity/onlineMatches/zhejiang/Rank.vue'),
    meta: {
      title: '浙江省跳绳大赛排名',
    },
  },
  {
    path: '/online-matches/zhejiang/landing',
    name: 'online_matches_zhejiang_landing',
    component: () => import('../activity/onlineMatches/zhejiang/Landing.vue'),
    meta: {
      title: '浙江省跳绳大赛',
    },
  },

  {
    path: '/online-matches/zhejiang/checkin',
    name: 'online_matches_zhejiang_checkin',
    component: () => import('../activity/onlineMatches/zhejiang/CheckIn.vue'),
    meta: {
      title: '浙江省跳绳比赛',
    },
  },
  {
    path: '/online-matches/zhejiang/checkin-rank',
    name: 'online_matches_zhejiang_checkin_rank',
    component: () => import('../activity/onlineMatches/zhejiang/CheckInRank.vue'),
    meta: {
      title: '浙江省跳绳大赛排名',
    },
  },
]

export const hamiRoutes = [
  {
    path: '/online-matches/hami',
    name: 'online_matches_hami',
    component: () => import('../activity/onlineMatches/hami/Index.vue'),
    meta: {
      title: '哈密市跳绳大赛',
    },
  },
  {
    path: '/online-matches/hami/rank',
    name: 'online_matches_hami_rank',
    component: () => import('../activity/onlineMatches/hami/Rank.vue'),
    meta: {
      title: '哈密市跳绳大赛排名',
    },
  },
  {
    path: '/online-matches/hami/landing',
    name: 'online_matches_hami_landing',
    component: () => import('../activity/onlineMatches/hami/Landing.vue'),
    meta: {
      title: '哈密市跳绳大赛',
    },
  },
]

export const guangdongXFIRoutes = [
  {
    path: '/online-matches/guangdong/xf-i',
    name: 'online_matches_guangdong_xf_i',
    component: () => import('../activity/onlineMatches/guangdongXFI/Index.vue'),
    meta: {
      title: '先锋校园赛第一期',
    },
  },
  {
    path: '/online-matches/guangdong/xf-i/rank',
    name: 'online_matches_guangdong_xf_i_rank',
    component: () => import('../activity/onlineMatches/guangdongXFI/Rank.vue'),
    meta: {
      title: '活动排名',
    },
  },
  {
    path: '/online-matches/guangdong/xf-i/landing',
    name: 'online_matches_guangdong_xf_i_landing',
    component: () => import('../activity/onlineMatches/guangdongXFI/Landing.vue'),
    meta: {
      title: '先锋校园赛第一期',
    },
  },
]

export const fujianRoutes = [
  {
    path: '/online-matches/fujian',
    name: 'online_matches_fujian',
    component: () => import('../activity/onlineMatches/fujian/Index.vue'),
    meta: {
      title: '2021福建省中小学生跳绳比赛',
    },
  },
  {
    path: '/online-matches/fujian/rank',
    name: 'online_matches_fujian_rank',
    component: () => import('../activity/onlineMatches/fujian/Rank.vue'),
    meta: {
      title: '大赛排名',
    },
  },
  {
    path: '/online-matches/fujian/landing',
    name: 'online_matches_fujian_landing',
    component: () => import('../activity/onlineMatches/fujian/Landing.vue'),
    meta: {
      title: '2021福建省中小学生跳绳比赛',
    },
  },
]

export const luoyangRoutes = [
  {
    path: '/online-matches/luoyang',
    name: 'online_matches_luoyang',
    component: () => import('../activity/onlineMatches/luoyang/Index.vue'),
    meta: {
      title: '2021年洛阳市洛龙区中小学线上跳绳运动积分赛',
    },
  },
  {
    path: '/online-matches/luoyang/rank',
    name: 'online_matches_luoyang_rank',
    component: () => import('../activity/onlineMatches/luoyang/Rank.vue'),
    meta: {
      title: '大赛排名',
    },
  },
  {
    path: '/online-matches/luoyang/landing',
    name: 'online_matches_luoyang_landing',
    component: () => import('../activity/onlineMatches/luoyang/Landing.vue'),
    meta: {
      title: '2021年洛阳市洛龙区中小学线上跳绳运动积分赛',
    },
  },
]

export const xichengRoutes = [
  {
    path: '/online-matches/xicheng',
    name: 'online_matches_xicheng',
    component: () => import('../activity/onlineMatches/xicheng/Index.vue'),
    meta: {
      title: '西城区中小学跳绳系列活动——线上跳绳比赛',
    },
  },
  {
    path: '/online-matches/xicheng/rank',
    name: 'online_matches_xicheng_rank',
    component: () => import('../activity/onlineMatches/xicheng/Rank.vue'),
    meta: {
      title: '大赛排名',
    },
  },
  {
    path: '/online-matches/xicheng/landing',
    name: 'online_matches_xicheng_landing',
    component: () => import('../activity/onlineMatches/xicheng/Landing.vue'),
    meta: {
      title: '西城区中小学跳绳系列活动——线上跳绳比赛',
    },
  },
]
export const haimenRoutes = [
  {
    path: '/online-matches/haimen',
    name: 'online_matches_haimen',
    component: () => import('../activity/onlineMatches/haimen/Index.vue'),
    meta: {
      title: '南通市海门区中小学线上跳绳比赛',
    },
  },
]

export const sipingRoutes = [
  {
    path: '/online-matches/siping',
    name: 'online_matches_siping',
    component: () => import('../activity/onlineMatches/siping/Index.vue'),
    meta: {
      title: '四平市中小学第一届寒假线上跳绳挑战',
    },
  },
  {
    path: '/online-matches/siping/rank',
    name: 'online_matches_siping_rank',
    component: () => import('../activity/onlineMatches/siping/Rank.vue'),
    meta: {
      title: '大赛排名',
    },
  },
]

export const guangdongWinterRoutes = [
  {
    path: '/online-matches/guangdong-winter',
    name: 'online_matches_guangdong_winter',
    component: () => import('../activity/onlineMatches/guangdong/Winter.vue'),
    meta: {
      title: '广东省第一届寒假线上跳绳挑战赛',
    },
  },
  {
    path: '/online-matches/guangdong-winter/rank',
    name: 'online_matches_guangdong_winter_rank',
    component: () => import('../activity/onlineMatches/guangdong/WinterRank.vue'),
    meta: {
      title: '大赛排名',
    },
  },
]
export const changzhouRoutes = [
  {
    path: '/online-matches/changzhou',
    name: 'online_matches_changzhou',
    component: () => import('../activity/onlineMatches/changzhou/Index.vue'),
    meta: {
      title: '常州市寒假中小学生线上跳绳积分赛',
    },
  },
  {
    path: '/online-matches/changzhou/rank',
    name: 'online_matches_changzhou_rank',
    component: () => import('../activity/onlineMatches/changzhou/Rank.vue'),
    meta: {
      title: '大赛排名',
    },
  },
]
export const lanzhouRoutes = [
  {
    path: '/online-matches/lanzhou',
    name: 'online_matches_lanzhou',
    component: () => import('../activity/onlineMatches/lanzhou/Index.vue'),
    meta: {
      title: '2022兰州新区线上跳绳挑战赛',
    },
  },
  {
    path: '/online-matches/lanzhou/rank',
    name: 'online_matches_lanzhou_rank',
    component: () => import('../activity/onlineMatches/lanzhou/Rank.vue'),
    meta: {
      title: '大赛排名',
    },
  },
]

// global pages
export const index: RouteConfig = {
  path: '/online-matches',
  name: 'online_matches',
  component: () => import('../activity/onlineMatches/Index.vue'),
  meta: {
    title: '线上赛事',
  },
}

export const cert: RouteConfig = {
  path: '/online-matches/cert/:activity',
  name: 'online_matches_cert',
  component: () => import('../activity/onlineMatches/Cert.vue'),
  props: (route) => ({ type: route.query.t, activity: route.params.activity }),
  meta: {
    title: '大赛证书',
  },
}

export const certV2: RouteConfig = {
  path: '/online-matches/cert/v2/:activity',
  name: 'online_matches_cert_v2',
  component: () => import('../activity/onlineMatches/Cert.vue'),
  props: (route) => ({ type: route.query.t, activity: route.params.activity, version: 2 }),
  meta: {
    title: '大赛证书',
  },
}

const preRoute = {
  path: '/online-matches/:activity/pre',
  name: 'online_matches_pre',
  component: () => import('../activity/onlineMatches/Main.vue'),
  props: (r: Route) => ({ activity: r.params.activity, stage: 0 }),
}

const mainRoute = {
  path: '/online-matches/:activity',
  name: 'online_matches_main',
  component: () => import('../activity/onlineMatches/Main.vue'),
  props: (r: Route) => ({ activity: r.params.activity }),
}

const rankRoute = {
  path: '/online-matches/:activity/rank',
  name: 'online_matches_rank',
  component: () => import('../activity/onlineMatches/Rank.vue'),
  props: (r: Route) => ({ activity: r.params.activity, id: r.query.id }),
}

const landing = {
  path: '/online-matches/:activity/user-info',
  name: 'online_matches_user_info',
  component: () => import('../activity/onlineMatches/UserInfo.vue'),
  props: true,
}

const userInfo = {
  path: '/online-matches/:activity/landing',
  name: 'online_matches_landing',
  component: () => import('../activity/onlineMatches/Landing.vue'),
  props: (r: Route) => ({ activity: r.params.activity }),
}

function genRoutes(key: string) {
  return [
    {
      path: `/online-matches/${key}/pre`,
      name: `online_matches_${key}_pre`,
      component: () => import(`../activity/onlineMatches/${key}/Index.vue`),
      props: { activity: key, stage: 0 },
    },
    {
      path: `/online-matches/${key}`,
      name: `online_matches_${key}`,
      component: () => import(`../activity/onlineMatches/${key}/Index.vue`),
      props: { activity: key },
    },
    {
      path: `/online-matches/${key}/rank`,
      name: `online_matches_${key}_rank`,
      component: () => import(`../activity/onlineMatches/${key}/Rank.vue`),
      props: { activity: key },
    },
  ]
}

const routerV2 = [
  {
    path: '/online-matches/v2/cert/:activity',
    name: 'online_matches_v2_cert',
    component: () => import('../activity/onlineMatches/v2/Cert.vue'),
    props: (route: Route) => ({ type: route.query.t, activity: route.params.activity }),
    meta: {
      title: '大赛证书',
    },
  },
  {
    path: '/online-matches/v2/:activity/reward',
    name: 'online_matches_v2_reward',
    component: () => import('../activity/onlineMatches/v2/Reward.vue'),
    props: (route: Route) => ({ id: route.params.activity }),
    meta: {
      title: '比赛证书',
    },
  },
  {
    path: '/online-matches/v2/:activity/pre',
    name: 'online_matches_v2_pre',
    component: () => import('../activity/onlineMatches/v2/Main.vue'),
    props: (r: Route) => ({ activity: r.params.activity, stage: 0 }),
  },
  {
    path: '/online-matches/v2/:activity',
    name: 'online_matches_v2_main',
    component: () => import('../activity/onlineMatches/v2/Main.vue'),
    props: (r: Route) => ({ activity: r.params.activity }),
  },
  {
    path: '/online-matches/v2/:activity/rank',
    name: 'online_matches_v2_rank',
    component: () => import('../activity/onlineMatches/v2/Rank.vue'),
    props: (r: Route) => ({ activity: r.params.activity, idx: +r.query.type || 0, gid: r.query.gid }),
  },
  {
    path: '/online-matches/v2/:activity/final-score',
    name: 'online_matches_v2_final_score',
    component: () => import('../activity/onlineMatches/v2/FinalScore.vue'),
    props: (r: Route) => ({ activity: r.params.activity }),
  },
  {
    path: '/online-matches/v2/:activity/final-school-score',
    name: 'online_matches_v2_final_school_score',
    component: () => import('../activity/onlineMatches/v2/FinalSchoolScore.vue'),
    props: (r: Route) => ({ activity: r.params.activity, schoolId: r.query.schoolId }),
  },
  {
    path: '/online-matches/v2/:activity/landing',
    name: 'online_matches_v2_landing',
    component: () => import('../activity/onlineMatches/v2/Landing.vue'),
    props: (r: Route) => ({ activity: r.params.activity }),
  },
  {
    path: '/online-matches/v2/:activity/record',
    name: 'online_matches_v2_record',
    component: () => import('../activity/onlineMatches/v2/Record.vue'),
    props: (r: Route) => ({ id: r.params.activity }),
  },
  {
    path: '/online-matches/v2/:activity/appeal',
    name: 'online_matches_v2_appeal_submit',
    component: () => import('../activity/onlineMatches/v2/AppealSubmit.vue'),
    props: (r: Route) => ({
      activity: r.params.activity,
      recordId: (r.query.record_id as string) || '',
    }),
    meta: { title: '申诉' },
  },
  {
    path: '/online-matches/v2/:activity/appeal-detail',
    name: 'online_matches_v2_appeal_detail',
    component: () => import('../activity/onlineMatches/v2/AppealDetail.vue'),
    props: (r: Route) => ({
      activity: r.params.activity,
      appealId: (r.query.appeal_id as string) || '',
    }),
    meta: { title: '详情' },
  },
]

const shandongEnroll = {
  path: '/online-matches/sdsqmspoint2204/pre',
  name: 'online_matches_sd_pre',
  component: () => import('../activity/onlineMatches/Enroll.vue'),
}

const marketingRoutes = [
  {
    path: '/online-matches/marketing/held-free',
    name: 'online_matches_marketing_held_free',
    component: () => import('../activity/onlineMatches/marketing/HeldFree.vue'),
    meta: {
      title: '体智云官方赛事免费举办',
    },
  },
]

export default [
  ...genRoutes('gn2201'),
  ...genRoutes('sd2203'),
  ...genRoutes('lwly202203'),
  ...genRoutes('gz2203'),
  ...genRoutes('hzpoint2203'),
  ...genRoutes('sddx2203'),
  shandongEnroll,
  index,
  cert,
  certV2,
  preRoute,
  mainRoute,
  rankRoute,
  landing,
  userInfo,
  ...routerV2,
  OnlineMatchUserMineRoute,
  OnlineMatchUserMatchListRoute,
  OnlineMatchUserAchievementRoute,
  OnlineMatchUserScoreRankRoute,
  ...marketingRoutes,
]
